import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: '#515669' }}>
      <Toolbar>
        {/* Hamburger Menu for mobile screens */}
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ display: { xs: 'block', sm: 'none' }, marginRight: 2 }}
          onClick={handleMenuOpen}
        >
          <MoreVertIcon />
        </IconButton>

        {/* Logo/Portfolio Name */}
        <Typography variant="h6" sx={{ flexGrow: 1, textAlign: 'center', color: '#f5f5f5' }}>
          My Portfolio
        </Typography>

        {/* Menu for larger screens */}
        <Box sx={{ display: { xs: 'none', sm: 'flex' }, gap: 2 }}>
          <Typography variant="button" component="a" href="/" sx={{ color: '#f5f5f5', textDecoration: 'none' }}>
            Home
          </Typography>
          <Typography variant="button" component="a" href="/about" sx={{ color: '#f5f5f5', textDecoration: 'none' }}>
            About
          </Typography>
          <Typography variant="button" component="a" href="/projects" sx={{ color: '#f5f5f5', textDecoration: 'none' }}>
            Projects
          </Typography>
          <Typography variant="button" component="a" href="/Skills" sx={{ color: '#f5f5f5', textDecoration: 'none' }}>
            Skills
          </Typography>
          <Typography variant="button" component="a" href="/Education" sx={{ color: '#f5f5f5', textDecoration: 'none' }}>
            Education
          </Typography>
          <Typography variant="button" component="a" href="/Experience" sx={{ color: '#f5f5f5', textDecoration: 'none' }}>
            Experience
          </Typography>
          <Typography variant="button" component="a" href="/contact" sx={{ color: '#f5f5f5', textDecoration: 'none' }}>
            Contact
          </Typography>
        </Box>

        {/* Dropdown menu for mobile screens */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleMenuClose} component="a" href="/">
            Home
          </MenuItem>
          <MenuItem onClick={handleMenuClose} component="a" href="/about">
            About
          </MenuItem>
          <MenuItem onClick={handleMenuClose} component="a" href="/projects">
            Projects
          </MenuItem>
          <MenuItem onClick={handleMenuClose} component="a" href="/Skills">
            Skills
          </MenuItem>
          <MenuItem onClick={handleMenuClose} component="a" href="/Education">
            Education
          </MenuItem>
          <MenuItem onClick={handleMenuClose} component="a" href="/Experience">
            Experience
          </MenuItem>
          <MenuItem onClick={handleMenuClose} component="a" href="/contact">
            Contact
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
